export enum ScanContentTypeEnum {
  html = 1,
  json = 2
}
